import {createEndpoint} from '@/logged/config';

export const userEndpoints = () => ({
    selectIdentity: createEndpoint<void, {identityId: string}>('selectIdentity'),
    acknowledgeOnboarding: createEndpoint<void>('acknowledgeOnboarding'),
});
